<router-outlet></router-outlet>

<app-map-loader *ngIf="globalLoader.isLoading() && !isWidgetsDemoPage && !isPdfExportPage" [errorMessage]="globalLoader.errorMessage()" [isShown]="true"></app-map-loader>

<app-cookie-consent-banner *ngIf="!isPdfExportPage"></app-cookie-consent-banner>
